import { UploadFilePage } from './pages';

export default [
    {
        path: '/uploadfile',
        element: <UploadFilePage />
    }
];